import StarsCanvas from '../3d/Stars';
import './Contact.css';
import { faGithub, faInstagram, faLinkedin, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from "motion/react"
const Footer = () => {
  return (
    <>
      <section className="relative w-full h-auto bg-center py-6 lg:py-8" id="contact">
        
        <motion.div 
        
        initial={{opacity:0.2,y:50}}
      transition={{duration:1}}
      whileInView={{opacity:1,y:0}}
      viewport={{once:true}}
        className="mx-auto w-full max-w-screen-xl px-4 py-6">
          <hr className="my-6 border-gray-600 sm:mx-auto lg:my-8 dark:border-black" />

          <div className="flex flex-col items-center justify-between sm:flex-row">
            <a href="/" className="flex-shrink-0">
              <img src="./l11.png" alt="Logo" className="h-[80px] w-auto sm:h-[110px] cursor-pointer" />
            </a>

            <span className="text-[15px] text-black font-bold mt-4 sm:mt-0 dark:text-gray-400">
              © {new Date().getFullYear()} <a href="/" className="underline">Amine Aj™</a>. All Rights Reserved.
            </span>

            <div className="flex mt-4 space-x-3 sm:mt-0">
              <a href="https://github.com/aminedevaj" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-black">
                <FontAwesomeIcon icon={faGithub} className="text-2xl" />
              </a>
              <a href="https://www.instagram.com/amine_8aj/" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">
                <FontAwesomeIcon icon={faInstagram} className="text-2xl" />
              </a>
              <a href="https://www.linkedin.com/in/amine-ajouihade-211719308/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-700">
                <FontAwesomeIcon icon={faLinkedin} className="text-2xl" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100088038682862" target="_blank" rel="noopener noreferrer" className="text-blue-700 hover:text-blue-800">
                <FontAwesomeIcon icon={faFacebook} className="text-2xl" />
              </a>
            </div>
          </div>
        </motion.div>
      </section>
    </>
  );
};

export default Footer;